import React from 'react';
import { motion } from 'framer-motion';
import { Droplet, HandMetal, Clock, Heart } from 'lucide-react';
export function HowToUseSection() {
  const steps = [{
    icon: <Droplet className="w-6 h-6 text-dark-900" data-id="element-109" />,
    title: '1) Aplicá una pequeña cantidad',
    desc: 'En la zona que querés estimular, con las manos limpias.'
  }, {
    icon: <HandMetal className="w-6 h-6 text-dark-900" data-id="element-110" />,
    title: '2) Masajeá suavemente',
    desc: 'Hasta que se absorba (toma 10–20 segundos).'
  }, {
    icon: <Clock className="w-6 h-6 text-dark-900" data-id="element-111" />,
    title: '3) Esperá 2–3 minutos',
    desc: 'Para que el efecto se active.'
  }, {
    icon: <Heart className="w-6 h-6 text-dark-900" data-id="element-112" />,
    title: '4) Disfrutá con más confianza',
    desc: 'La sensación sube, el control mejora, el momento se siente más tuyo.'
  }];
  return <section className="w-full bg-dark-900 py-24 px-4" data-id="element-113">
      <div className="max-w-5xl mx-auto" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-115">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-116">
            CÓMO SE USA
          </h2>
          <p className="text-gray-400" data-id="element-117">Paso a paso simple</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative" data-id="element-118">
          {/* Connecting line for desktop */}
          <div className="hidden lg:block absolute top-8 left-[10%] right-[10%] h-0.5 bg-dark-800 -z-0" data-id="element-119" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-120">
              <div className="w-16 h-16 rounded-full bg-gold-500 flex items-center justify-center mb-6 shadow-lg shadow-gold-500/20" data-id="element-121">
                {step.icon}
              </div>
              <h3 className="text-lg font-bold text-white mb-2" data-id="element-122">
                {step.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-123">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}